import { EventDetails, EventServiceEvent } from '../types/event';

/** start/end come without offset (`2026-08-03T06:00:00.0000000`), zone in `timeZone`. */
export function parseEventServiceDate(value: string, timeZone: string): Date {
  const hasOffset = /(Z|[+-]\d{2}:?\d{2})$/.test(value);
  const normalized = value.replace(/(\.\d{3})\d+/, '$1');
  if (!hasOffset && timeZone === 'UTC') return new Date(`${normalized}Z`);
  return new Date(normalized);
}

export function toEventDetails(event: EventServiceEvent): EventDetails {
  return {
    subject: event.subject,
    start: parseEventServiceDate(event.start, event.timeZone),
    end: parseEventServiceDate(event.end, event.timeZone),
    allDay: event.isAllDay ?? false,
    location: event.location,
    organizer: event.organizer,
    attendees: event.attendees,
    status: event.status,
    isOnline: event.isOnline,
    onlineMeetingUrl: event.onlineMeetingUrl,
    description: event.bodyPreview,
  };
}
